var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.no_amount)?_c('b',[_vm._v(_vm._s(_vm._f("abbrev")(_vm.eth_amount,_vm.mq_lte_sm ? 3 : null)))]):_vm._e(),_c('span',{staticClass:"currency"},[_c('CurrencyIcon',{attrs:{"currency":"ETH"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }